import React, { createContext } from 'react';
import i18n, { ResourceLanguage } from 'i18next';
import { initReactI18next, I18nextProvider } from 'react-i18next';
import { i18n as otpUiTranslations } from '@otp/ui';
import get from 'lodash.get';

import { i18n as otpDashboardTranslations } from '../i18n';
import { Routes } from 'src/components/common/router/constants';

const languages = ['en'];

const combineTranslations = () => {
  const languagesMap: { [key: string]: ResourceLanguage } = {};
  languages.forEach((langCode) => {
    const combinedTranslations = [
      ...otpUiTranslations,
      otpDashboardTranslations,
    ].reduce(
      (mergedTranslation, translation) => ({
        ...mergedTranslation,
        ...translation[langCode],
      }),
      {},
    );

    languagesMap[langCode] = {
      translation: combinedTranslations,
    };
  });

  return languagesMap;
};

const combinedTranslations = combineTranslations();

i18n.use(initReactI18next).init({
  resources: combinedTranslations,
  lng: 'en',
  fallbackLng: 'en',
  nsSeparator: '::',
});

i18n.services.formatter?.add('printArray', (value, lng, options) => {
  const field = options.field; // Get the field passed to the formatter
  if (Array.isArray(value) && field) {
    return value.map((item) => item[field]).join(', ');
  }

  return value; // Fallback for non-array values
});

i18n.services.formatter?.add('link', (value, lng, options) => {
  const { route: routeName, id, interpolationkey: linkText } = options;
  const idValue = id ? get(options, id, id) : undefined;
  const route = Routes[routeName]
    ? [Routes[routeName].path, idValue].filter(Boolean).join('/')
    : '/';

  return `<a target="_blank" href="${route}">${linkText}</a>`;
});

const I18nContext = createContext({});

function TranslationContextProvider({
  children,
}: {
  children?: React.ReactNode;
}) {
  return (
    <I18nContext.Provider value={{}}>
      <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
    </I18nContext.Provider>
  );
}

export { TranslationContextProvider };
